import { render, staticRenderFns } from "./SubconSummary.vue?vue&type=template&id=4945730d&scoped=true"
import script from "./SubconSummary.vue?vue&type=script&lang=js"
export * from "./SubconSummary.vue?vue&type=script&lang=js"
import style0 from "./SubconSummary.vue?vue&type=style&index=0&id=4945730d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945730d",
  null
  
)

export default component.exports